export { default } from './BensServicosPJParcelaFacilitada';
